import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Facebook, Clock } from "lucide-react";
import { OWNER_PHONE, OWNER_EMAIL, LOCATION, api } from "@/api";
import { toast } from "sonner";

export const Footer = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Iscrizione confermata!");
      setEmail("");
    } catch { toast.error("Errore, riprova"); }
    setLoading(false);
  };

  return (
    <footer className="bg-[#0B0B0C] border-t border-white/10 mt-24">
      {/* CTA banner */}
      <div className="border-b border-white/10 bg-gradient-to-r from-[#0B0B0C] via-[#1A1A1E] to-[#0B0B0C]">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-display text-lg md:text-xl font-bold tracking-widest text-white text-center md:text-left">
            <span className="gold-text">CONTATTACI:</span> SCOPRI TUTTI I NOSTRI VEICOLI!
            <span className="block md:inline text-[#E1BC56] ml-0 md:ml-3">{OWNER_PHONE}</span>
          </div>
          <Link to="/contatti" className="cmc-btn-gold px-8 py-3 rounded-sm" data-testid="footer-cta-scrivici">SCRIVICI</Link>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <img src="https://customer-assets-0z36b82j.emergentagent.net/job_cmc-auto-altamura/artifacts/b8y38fm5_Gemini_Generated_Image_9jbrw79jbrw79jbr.jpg" alt="LC AUTO" className="h-14 object-contain mb-3" style={{ mixBlendMode: "screen", background: "transparent" }} />
          <p className="text-sm text-zinc-400 leading-relaxed mb-4">
            Concessionaria auto ad Altamura (BA). Ogni tipologia di veicolo (utilitarie, SUV, berline, sportive) con i massimi standard qualitativi. Proprietà di Luigi Cornacchia.
          </p>
          <div className="flex gap-3">
            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#E1BC56] hover:text-[#E1BC56] transition"><Instagram className="w-4 h-4" /></a>
            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#E1BC56] hover:text-[#E1BC56] transition"><Facebook className="w-4 h-4" /></a>
            <a href="https://tiktok.com" target="_blank" rel="noreferrer" className="w-9 h-9 rounded-sm border border-white/10 flex items-center justify-center hover:border-[#E1BC56] hover:text-[#E1BC56] transition text-xs font-bold">TT</a>
          </div>
        </div>

        <div>
          <div className="font-display text-sm font-bold tracking-widest text-white mb-4">CONTATTI</div>
          <ul className="text-sm text-zinc-400 space-y-2.5">
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[#E1BC56]" /> {OWNER_PHONE}</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[#E1BC56]" /> {OWNER_EMAIL}</li>
            <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#E1BC56]" /> {LOCATION}</li>
          </ul>
        </div>

        <div>
          <div className="font-display text-sm font-bold tracking-widest text-white mb-4">ORARI</div>
          <ul className="text-sm text-zinc-400 space-y-2.5">
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#E1BC56]" /> Lun-Ven: 9:00 - 13:00 / 15:30 - 19:30</li>
            <li className="flex items-center gap-2"><Clock className="w-4 h-4 text-[#E1BC56]" /> Sab: 9:00 - 13:00</li>
            <li className="text-zinc-500">Domenica: Chiuso (su appuntamento)</li>
          </ul>
          <a href="https://www.subito.it" target="_blank" rel="noreferrer" className="mt-4 inline-block text-xs text-[#E1BC56] hover:text-[#F3E29F] tracking-widest uppercase" data-testid="footer-subito-link">
            → I nostri annunci su Subito.it
          </a>
        </div>

        <div>
          <div className="font-display text-sm font-bold tracking-widest text-white mb-4">NEWSLETTER</div>
          <p className="text-sm text-zinc-400 mb-3">Novità, arrivi esclusivi e offerte riservate.</p>
          <form onSubmit={subscribe} className="flex gap-2" data-testid="newsletter-form">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="La tua email" data-testid="newsletter-email"
              className="flex-1 bg-[#121214] border border-white/10 rounded-sm px-3 py-2 text-sm text-white focus:border-[#E1BC56] focus:outline-none" />
            <button disabled={loading} className="cmc-btn-gold px-4 py-2 rounded-sm text-xs" data-testid="newsletter-submit">OK</button>
          </form>
        </div>
      </div>

      <div className="border-t border-white/5 py-5 text-center text-xs text-zinc-500">
        © {new Date().getFullYear()} LC Auto di Luigi Cornacchia · Altamura (BA) · P.IVA in comunicazione
      </div>
    </footer>
  );
};
